// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"/js/manifest": 0,
	"css/vendor": 0,
	"css/splash_v2": 0,
	"css/casino/designs/modern": 0,
	"css/mobile": 0,
	"css/errors": 0,
	"css/styles": 0,
	"css/app": 0,
	"css/MiniGames/index": 0,
	"css/components/iframes/iframe_results": 0,
	"css/account/MyAccount": 0,
	"css/account/account": 0,
	"css/gg-payments/gg-payments": 0,
	"css/play/lootbox": 0,
	"css/play/raffle": 0,
	"css/play/pick": 0,
	"css/play/keno": 0,
	"css/MiniGames/GgWorldTicTacBoo/theme": 0,
	"css/MiniGames/GgWorldSantaInDaHouse/theme": 0,
	"css/MiniGames/GgWorldRedOrBlue/theme": 0,
	"css/MiniGames/GgWorldCoinFlip/theme": 0,
	"css/affiliate/promote": 0,
	"css/casino/designs/sleek_v2": 0,
	"css/casino/designs/sleek": 0,
	"css/casino/designs/deposit-social-casino": 0,
	"css/casino/styles": 0,
	"css/casino/app": 0,
	"css/components/gamification_missions": 0,
	"css/components/daily_wheel": 0,
	"css/components/draw_animation": 0
};

__webpack_require__.f.j = (chunkId, promises) => {
		// JSONP chunk loading for javascript
		var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
		if(installedChunkData !== 0) { // 0 means "already installed".

			// a Promise means "currently loading".
			if(installedChunkData) {
				promises.push(installedChunkData[2]);
			} else {
				if(!/^(css\/(MiniGames\/(GgWorld(CoinFlip|RedOrBlue|SantaInDaHouse|TicTacBoo)\/theme|index)|a(ccount\/(MyA|a)ccount|ffiliate\/promote|pp)|c(asino\/(designs\/(sleek(|_v2)|deposit\-social\-casino|modern)|app|styles)|omponents\/(daily_wheel|draw_animation|gamification_missions|iframes\/iframe_results))|play\/(keno|lootbox|pick|raffle)|(error|gg\-payments\/gg\-payment|style)s|mobile|splash_v2|vendor)|\/js\/manifest)$/.test(chunkId)) {
					// setup Promise in chunk cache
					var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
					promises.push(installedChunkData[2] = promise);

					// start chunk loading
					var url = __webpack_require__.p + __webpack_require__.u(chunkId);
					// create error before stack unwound to get useful stacktrace later
					var error = new Error();
					var loadingEnded = (event) => {
						if(__webpack_require__.o(installedChunks, chunkId)) {
							installedChunkData = installedChunks[chunkId];
							if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
							if(installedChunkData) {
								var errorType = event && (event.type === 'load' ? 'missing' : event.type);
								var realSrc = event && event.target && event.target.src;
								error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
								error.name = 'ChunkLoadError';
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							}
						}
					};
					__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
				} else installedChunks[chunkId] = 0;
			}
		}
};

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunkgglotto"] = self["webpackChunkgglotto"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));